module.exports = __webpack_public_path__ + "static/media/KLAY.30078d1a.svg";